// API base URL - uses empty string for same-origin relative paths
// This works on both preview (*.preview.emergentagent.com) and production (fxcvantage.com)
// since both route /api/* to the backend
export const BACKEND_URL = '';
